export default class TechnicalBackgroundInfo {
  public static fromJSON(value: string | null | undefined): TechnicalBackgroundInfo | null | undefined {
    if (value === null || value === undefined) return value;
    if (!value || value === '') return null;
    return new TechnicalBackgroundInfo(value);
  }

  public constructor(public readonly value: string) { }

  public toJSON(): string { return this.value }
}
